import React, { useEffect, useState } from "react";
import style from "./workingFile.module.scss";
import { dateFormateDD } from "../../utility";
function InvoiceDetails({ employerDetails, invoicedata, invoiceNumber }) {
  const [getinvoiceNumber, setinvoiceNumber] = useState();
  useEffect(() => {
    // console.log(invoiceNumber);
    // setinvoiceNumber(invoiceNumber);
  }, [invoicedata, employerDetails, invoiceNumber]);

  const email = employerDetails?.emailId || "";
  // const email = "sivaranarajanithiyagarajanvind12@gmail.com";
  const maxLength = 38;

  let splitEmail;
  if (email && email.length > maxLength) {
    const localPart = email.slice(0, maxLength);
    const domainPart = email.slice(maxLength);
    splitEmail = localPart + "<br />" + domainPart;
  } else {
    splitEmail = email || "N/A";
  }

  return (
    <div className={style.invoiceContainer}>
      <div className={`row ${style.invoiceDetails}`}>
        <div className={`col-sm-6 ${style.invoiceInfo}`}>
          <div className="d-flex justify-content-between">
            <div>
              <div>Corporate Identity # </div>
              <div>GSTIN # </div>
              <div>PAN # </div>
            </div>
            <div>
              <div>&nbsp;-&nbsp;&nbsp; U74999TN2018BPTC123524</div>
              <div>&nbsp;-&nbsp;&nbsp; 33AAGCT8375E1Z6</div>
              <div>&nbsp;-&nbsp;&nbsp; AAGCT8375E</div>
            </div>
          </div>
        </div>
        <div className={`col-sm-4 ${style.invoiceInfo}`}>
          <div className="d-flex justify-content-between">
            <div className="ms-5">
              <div>
                <b>Date</b>
              </div>
              <div>
                <b>Invoice&nbsp;#&nbsp;</b>
              </div>
            </div>
            <div>
              <div>-&nbsp;&nbsp; {dateFormateDD(invoicedata.invoiceDate)}</div>
              {/* {dateFormateDD(invoicedata.invoiceDate)} */}
              <div>
                -&nbsp;&nbsp;
                <span style={{ fontSize: "12.3px" }}>
                  {" "}
                  {/* {invoiceNumber != null ? "TZ/XX-XX/XXXXX" : "TZ/XX-XX/XXXXX"} */}
                  {invoiceNumber != null ? invoiceNumber : "TZ/XX-XX/XXXXX"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2"></div>
      </div>
      <div>
        <div className={`${style.hr1}`}></div>
        <h6
          style={{
            color: "#169c50",
            fontWeight: "bold",
            // marginBottom: "10px",
            paddingLeft: "40px",
          }}
        >
          INVOICE TO:
        </h6>
      </div>
      <div className={`row ${style.invoiceCompanyDetails}`}>
        <div className={`col-sm-7 ${style.invoiceGstInfo1}`}>
          <div className={`${style.companyName}`}>
            <b>{employerDetails?.companyName || "N/A"}</b>
          </div>
          <div>{employerDetails?.address || "N/A"}</div>
        </div>
        <div
          className={`${email.length > 25 ? "col-sm-5" : "col-sm-4"} ${
            style.invoiceGstInfo1
          }`}
        >
          <div className="d-flex justify-content-between mt-1">
            <div className="">
              <div>
                <b>GSTIN&nbsp;#&nbsp; </b>
              </div>
              <div>
                <b>Phone</b>{" "}
              </div>
              <div>
                <b>Email </b>
              </div>
            </div>
            <div>
              <div>-&nbsp;&nbsp; {employerDetails?.regProofNumber}</div>
              <div>-&nbsp;&nbsp; +91 {employerDetails?.mobileNumber}</div>
              {/* <div>-&nbsp;&nbsp; {splitEmail}</div> */}
              <div>
                -&nbsp;&nbsp;{" "}
                <span dangerouslySetInnerHTML={{ __html: splitEmail }} />{" "}
              </div>

              {/* <div>-&nbsp;&nbsp; sivaranjanithiyagarajan12@gmail.com</div> */}
            </div>
          </div>
          {/* <div className="d-flex justify-content-between">
            <div className="">
              <div>
                <b>Email </b>
              </div>
            </div>
            <div>
              <div>-&nbsp;&nbsp; {splitEmail}</div>
            </div>
          </div> */}
        </div>
        <div className="col-sm-1"></div>
      </div>
    </div>
  );
}

export default InvoiceDetails;
